import apiClient from './client';
import { API_ENDPOINTS } from './config';
import type { StaffMember, StaffFormData, StaffByTaskGroup } from '../types/staff';

export const staffApi = {
	listStaff: async (locationId: number): Promise<StaffMember[]> => {
		return apiClient.get<StaffMember[]>(`${API_ENDPOINTS.STAFF.BASE}?locationId=${locationId}`);
	},

	createStaff: async (locationId: number, data: StaffFormData): Promise<StaffMember> => {
		return apiClient.post<StaffMember>(
			`${API_ENDPOINTS.STAFF.BASE}?locationId=${locationId}`,
			data
		);
	},

	updateStaff: async (
		staffId: number,
		locationId: number,
		data: StaffFormData
	): Promise<StaffMember> => {
		return apiClient.put<StaffMember>(
			`${API_ENDPOINTS.STAFF.DETAIL(staffId)}?locationId=${locationId}`,
			data
		);
	},

	getStaffByTasks: async (
		locationId: number,
		serviceTaskIds: number[]
	): Promise<StaffByTaskGroup[]> => {
		const queryParams = new URLSearchParams();
		queryParams.append('locationId', String(locationId));
		serviceTaskIds.forEach(id => queryParams.append('serviceTaskIds', String(id)));
		return apiClient.get<StaffByTaskGroup[]>(
			`${API_ENDPOINTS.STAFF.BY_TASKS}?${queryParams.toString()}`
		);
	},

	getStaffDetail: async (staffId: number, locationId: number): Promise<StaffMember> => {
		return apiClient.get<StaffMember>(
			`${API_ENDPOINTS.STAFF.DETAIL(staffId)}?locationId=${locationId}`
		);
	},

	searchStaff: async (query: string): Promise<StaffMember[]> => {
		return apiClient.get<StaffMember[]>(
			`${API_ENDPOINTS.STAFF.SEARCH}?query=${encodeURIComponent(query)}`
		);
	},
};

export default staffApi;
